import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import './App.css';
import C1Calc from './components/C1Calc';
import C1Result from './components/C1Results';
import useIsSmartphone from './components/useIsSmartphone';
import useIsTablet from './components/useIsTablet';

const FlexContainer = styled.div`
  @media (min-width: 769px) {
    display: flex;
    text-align: left;
    
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: left;
  }
`;

const AppContent = () => {
  const { lang } = useParams(); // Get language from URL
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (lang && ['en', 'de', 'es', 'fr', 'it', 'ko', 'zh', 'pl', 'nl', 'sl'].includes(lang)) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage('en'); // Default to English if language is not recognized
    }
  }, [lang, i18n]);

  const isSmartphone = useIsSmartphone();
  const isTablet = useIsTablet();

  const [sLf1Dia, setSLf1Dia] = useState('-');
  const [sLf1Surface, setSLf1Surface] = useState('-');
  const [sLf2Dia, setSLf2Dia] = useState('-');
  const [sLf2Surface, setSLf2Surface] = useState('-');
  const [sLf3Dia, setSLf3Dia] = useState('-');
  const [sLf3Surface, setSLf3Surface] = useState('-');
  const [targetC1wid1, setTargetC1wid1] = useState(0);
  const targetC1wid1Ref = useRef(targetC1wid1);

  useEffect(() => {
    targetC1wid1Ref.current = targetC1wid1;
  }, [targetC1wid1]);

  useEffect(() => {
    const updateTargetWidth = () => {
      let k2;
      /*
      if (window.innerWidth > 935) {
        k2 = window.innerWidth * 0.31 + 560;
      } else if (window.innerWidth > 868 && window.innerWidth <= 934) {
        k2 = 851;
      } else {
        k2 = window.innerWidth - 18;  //853;
      }
      */
      if (window.innerWidth > 1230) {
        k2 = 1230;
      } else if (window.innerWidth > 868 && window.innerWidth <= 1230) {
        k2 = window.innerWidth * 1 + 0;
      } else {
        k2 = window.innerWidth - 18;  //853;
      }

      setTargetC1wid1(Math.min(k2, 1230));
      //setTargetC1wid1(k2);
    };

    updateTargetWidth();
    window.addEventListener('resize', updateTargetWidth);
    return () => {
      window.removeEventListener('resize', updateTargetWidth);
    };
  }, []);

  let titleMarginLeft;
  if (isSmartphone) {
    titleMarginLeft = '20px';
  } else if (isTablet) {
    titleMarginLeft = '40px';
  } else {
    titleMarginLeft = '45px';
  }

  return (
    <div style={{ backgroundColor: '#f3f3f3', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <br />
      <br />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ height: '50px', width: targetC1wid1, backgroundColor: '#0078c9', display: 'flex', alignItems: 'center' }}>
          <p style={{ marginLeft: titleMarginLeft, color: 'white', fontFamily: 'Arial', fontWeight: '400', fontSize: '1.7rem' }}>
            {t('Suction cup diameter')}
          </p>
        </div>
      </div>

      <FlexContainer style={{ width: '1230px', maxWidth: '100%' }}>
        <C1Calc
          bgColor="white"
          setSLf1Dia={setSLf1Dia}
          setSLf1Surface={setSLf1Surface}
          setSLf2Dia={setSLf2Dia}
          setSLf2Surface={setSLf2Surface}
          setSLf3Dia={setSLf3Dia}
          setSLf3Surface={setSLf3Surface}
        />

        <div style={{ backgroundColor: '#f3f3f3', width: '10px' }}>
          <p>{' '}</p>
        </div>

        <C1Result
          bgColor="#d5d5d5"
          sLf1Dia={sLf1Dia}
          sLf1Surface={sLf1Surface}
          sLf2Dia={sLf2Dia}
          sLf2Surface={sLf2Surface}
          sLf3Dia={sLf3Dia}
          sLf3Surface={sLf3Surface}
        />
      </FlexContainer>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Redirect root to English by default */}
        <Route path="/" element={<Navigate to="/en" />} />
        {/* Handle all language routes */}
        <Route path="/:lang" element={<AppContent />} />
      </Routes>
    </Router>
  );
};

export default App;
